import { render } from "./video-placeholder-fullpage.vue?vue&type=template&id=0fb42794"
import script from "./video-placeholder-fullpage.vue?vue&type=script&lang=js"
export * from "./video-placeholder-fullpage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__